import { SKILLS } from "@/data/portfolio";
import { useReveal } from "@/hooks/useReveal";

const marqueeItems = [
  ["HTML5", "CSS3", "JavaScript", "React", "Tailwind CSS"],
  ["Bootstrap", "Figma", "WordPress", "Git", "GitHub"],
];

export default function Skills() {
  const { ref, visible } = useReveal();
  return (
    <section id="skills" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10" ref={ref}>
        <div className={`max-w-2xl mb-14 fade-in-up ${visible ? "in" : ""}`}>
          <div className="section-label mb-4">Skills & Stack</div>
          <h2 className="heading-hero text-4xl md:text-5xl lg:text-6xl">
            My daily <span className="text-[#FF3B30]">toolkit.</span>
          </h2>
          <p className="text-white/60 mt-4">
            The technologies I use every day to build fast, accessible, and delightful websites.
          </p>
        </div>

        {/* Skill grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 mb-16">
          {SKILLS.map((s, i) => (
            <div
              key={s.name}
              className={`glass-card rounded-2xl p-5 group fade-in-up ${visible ? "in" : ""}`}
              style={{ transitionDelay: `${i * 40}ms` }}
              data-testid={`skill-card-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="flex items-baseline justify-between mb-3">
                <p className="font-display font-semibold text-base">{s.name}</p>
                <span className="text-xs text-[#FF3B30] font-bold">{s.level}%</span>
              </div>
              <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#FF3B30] to-[#ff7a63] rounded-full transition-all duration-1000 ease-out"
                  style={{ width: visible ? `${s.level}%` : "0%" }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Marquee */}
        <div className="relative overflow-hidden py-6 mask-marquee">
          <div className="flex animate-marquee whitespace-nowrap gap-8">
            {[...marqueeItems.flat(), ...marqueeItems.flat(), ...marqueeItems.flat()].map((label, i) => (
              <div key={i} className="flex items-center gap-4 shrink-0">
                <span className="text-3xl md:text-5xl font-display font-black text-white/10 hover:text-[#FF3B30] transition-colors">
                  {label}
                </span>
                <span className="w-2 h-2 rounded-full bg-[#FF3B30]/40" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
